import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { PERMISSIONS } from "app/utils/permissions";

const TentativeDiagnosisList = Loadable(lazy(() => import("./TentativeDiagnosisList")));
const TentativeDiagnosisForm = Loadable(lazy(() => import("./TentativeDiagnosisForm")));

const tentativeDiagnosisRoutes = [
  {
    path: "/TentativeDiagnosis/TentativeDiagnosisList",
    element: <TentativeDiagnosisList />,
    permission: PERMISSIONS.TentativeDiagnosis.Menu,
  },
  {
    path: "/TentativeDiagnosis/TentativeDiagnosisForm",
    element: <TentativeDiagnosisForm />,
  },
  {
    path: "/TentativeDiagnosis/TentativeDiagnosisForm/:tentativeDiagnosisId",
    element: <TentativeDiagnosisForm />,
  },
];

export default tentativeDiagnosisRoutes;
